import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllCompanyDetails = () => {
  const [companyDetails, setCompanyDetails] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/company`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        const data = result?.data?.data;
        setCompanyDetails(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleAddCompany = () => {
    navigate("/add-company-details");
  };

  const handleViewAllCompany = () => {
    navigate("/all-company-details");
  };

  const handleEdit = (id) => {
    navigate(`/edit-company-details/${id}`);
  };
  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete.");
    if (confirmDelete) {
      axios
        .delete(`${API_BASE_URL}/admin/company/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => {
          console.log(result);
          alert("Company detail deleted successfully.");
        })
        .catch((error) => {
          console.log(error);
          alert("Error while deleting detail.");
        });
    }
  };

  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>All Company Details</h5>
        <div className="classes-header-btns">
          <button className="add-class-btn" onClick={handleAddCompany}>
            + Add Company
          </button>
          <button className="all-classes-btn" onClick={handleViewAllCompany}>
            All Company
          </button>
        </div>
      </div>

      <div className="classes-table-container">
        <h5>All Company</h5>
        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>name</th>
              <th>email</th>
              <th>phone</th>
              <th>website</th>
              <th>address</th>
              <th>emergency contact</th>
              <th>gst in</th>

              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {/* Sample data rows */}

            {companyDetails.map((data, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{data.name}</td>
                <td>{data.email}</td>
                <td>{data.phone}</td>
                <td>{data.website}</td>
                <td>{data.address}</td>
                <td>{data.emergencyContact}</td>
                <td>{data.gstin}</td>

                <td className="table-action-icons d-flex ">
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(data._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(data._id)}
                  ></i>
                </td>
              </tr>
            ))}

            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllCompanyDetails;
